import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import SelectGrid from "../../select-grid";
import { TipoFormulario } from "../../../services/constantes";

export const SelectGridFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, errors,
}) => (
  <>
    <SelectGrid
      height={campo.selectGridProps?.height}
      modo={modo || TipoFormulario.tpNenhum}
      columns={campo.selectGridProps?.columns || []}
      dataSource={campo.selectGridProps?.dataSource || []}
      gridColumns={campo.selectGridProps?.gridColumns || []}
      initialGridData={campo.selectGridProps?.initialGridData}
      iconeBotaoExtra={campo.selectGridProps?.iconeBotaoExtra}
      tituloBotaoExtra={campo.selectGridProps?.tituloBotaoExtra}
      onAcaoExtra={campo.selectGridProps?.onAcaoExtra || (() => {})}
      useGridOptions={campo.selectGridProps?.useGridOptions || false}
      optionLabelField={campo.selectGridProps?.optionLabelField || ""}
      criticarRepeticao={campo.selectGridProps?.criticarRepeticao || false}
      onDataSourceChange={campo.selectGridProps?.onDataSourceChange || (() => {})}
      setData={campo.selectGridProps?.setData}
      forceUpdate={campo.selectGridProps?.forceUpdate}
      orderByField={campo.selectGridProps?.orderByField}
      maxRecords={campo.selectGridProps?.maxRecords || 1000}
      groupByField={campo.selectGridProps?.groupByField}
      groupStyles={campo.selectGridProps?.groupStyles}
      groupBadgeStyles={campo.selectGridProps?.groupBadgeStyles}
      formatGroupLabel={campo.selectGridProps?.formatGroupLabel}
      modalTitle={campo.selectGridProps?.modalTitle}
      modalCancelButtonText={campo.selectGridProps?.modalCancelButtonText}
      modalSaveButtonText={campo.selectGridProps?.modalSaveButtonText}
      diffField={campo.selectGridProps?.diffField}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
